module.exports = __webpack_public_path__ + "img/drag-handle.c5cc48a5.svg";